"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressStatuses = exports.PremissionTypes = exports.DeliverableFileTypes = exports.DeliverableValueTypes = exports.DeliverableType = exports.DeliverableTypeIterable = void 0;
exports.DeliverableTypeIterable = [
    'backupServicerReport',
    'backupServicingPlan',
    'bankStatement',
    'borrowingBaseCertificate',
    'borrowingBaseReport',
    'budget',
    'collateralAndServicingReport',
    'collateralVerification',
    'complianceCertificate',
    'complianceStatement',
    'financialStatement',
    'loanTape',
    'managementReport',
    'officersCertificate',
    'other',
    'performanceReport',
    'projections',
    'remittanceDate',
    'remittanceReport',
    'servicerReport',
    'settlementReport',
];
exports.DeliverableType = {
    BackupServicerReport: 'backupServicerReport',
    BackupServicingPlan: 'backupServicingPlan',
    BankStatement: 'bankStatement',
    BorrowingBaseCertificate: 'borrowingBaseCertificate',
    BorrowingBaseReport: 'borrowingBaseReport',
    Budget: 'budget',
    CollateralAndServicingReport: 'collateralAndServicingReport',
    CollateralVerification: 'collateralVerification',
    ComplianceCertificate: 'complianceCertificate',
    ComplianceStatement: 'complianceStatement',
    FinancialStatement: 'financialStatement',
    LoanTape: 'loanTape',
    ManagementReport: 'managementReport',
    OfficersCertificate: 'officersCertificate',
    Other: 'other',
    PerformanceReport: 'performanceReport',
    Projections: 'projections',
    RemittanceDate: 'remittanceDate',
    RemittanceReport: 'remittanceReport',
    ServicerReport: 'servicerReport',
    SettlementReport: 'settlementReport',
};
exports.DeliverableValueTypes = [
    'noSubmission',
    'file',
    'string',
    'number',
    'boolean',
];
exports.DeliverableFileTypes = [
    'csv',
    'docx',
    'doc',
    'pdf',
    'xlsx',
    'xls',
    'txt',
    'zip',
    'png',
    'jpg', // jpg + jpeg have the same mime type
];
exports.PremissionTypes = ['download', 'view'];
exports.ProgressStatuses = [
    'notSubmitted',
    'submitted',
    'resubmit',
    'waived',
];
//# sourceMappingURL=v3DEPRECATED.js.map